<template>
  <div class="container">
    <el-button type="primary">buttonCont</el-button>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-table
          :data="allCanteenList"
          :height="400"
        >
      <el-table-column
        header-align="center"
        align="center"
        prop="canteen_name"
        label="餐厅"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="eatery_name"
        label="所属食堂"
      >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="eatery_account"
            label="账号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="eatery_pwd"
            label="密码"
          >
          </el-table-column>
        </el-table>
      </el-col>
     <el-col :span="12">
       <el-table
         :data="allCanteenList"
         :height="400"
       >
      <el-table-column
        header-align="center"
        align="center"
        prop="canteen_name"
        label="餐厅"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="eatery_name"
        label="所属食堂"
      >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="eatery_account"
            label="账号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="eatery_pwd"
            label="密码"
          >
          </el-table-column>
        </el-table>
     </el-col>
    </el-row>
  </div>
</template>
<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
import {apiGetEateryList} from '@/api';

export default {
  name: '',
  components: {},
  data () {
    return {};
  },
  mounted () {
    this.setSubTitle('餐厅管理');
    this.setAllCanteenList();
  },
  methods: {
    ...mapMutations([
      'setSubTitle'
    ]),
    ...mapActions([
      'setAllCanteenList'
    ])
  },
  computed: {
    ...mapGetters([
      'allCanteenList'
    ])
  },
  watch: {}
};
</script>
<style>

</style>
